import { render } from "./BrowseTemplatesChip.vue?vue&type=template&id=6cbe19aa"
import script from "./BrowseTemplatesChip.vue?vue&type=script&lang=js"
export * from "./BrowseTemplatesChip.vue?vue&type=script&lang=js"
script.render = render

export default script